import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import CustomerCompanyDetailPageProps from './customerCompanyDetailPageProps';
import Button from '../buttons/button';
import ConfirmationPrompt from '../containers/confirmationPrompt';
import Alert from '../alerts/alert';
import ButtonColors from '../buttons/buttonColors';
import AllMeetingsTable from '../meetings/allMeetingsTable';

class CustomerCompanyDetailPage extends ObservingComponent<CustomerCompanyDetailPageProps> {

    public componentWillMount(): void {
        this.registerUpdateObserver(this.props.page.observationProvider);
    }

    public render({ page }: CustomerCompanyDetailPageProps): JSX.Element {
        const customerCompany = page.form?.model;
        const customerCompanyName = customerCompany.name ? customerCompany.name : '';
        const customerCompanyLocation = customerCompany ? `${customerCompany.streetAddress}, ${customerCompany.city}, ${customerCompany.state} ${customerCompany.postalCode}, ${customerCompany.country}`.trim() : '';

        return (
            <div>
                <ConfirmationPrompt confirmationPrompt={page.confirmationPrompt} />
                <Alert alert={page.alert} />

                <div>
                    <div class="page-title">Company Detail</div>
                    <div class="customer-detail-page">
                        <div class="page-heading">
                            <h3>{customerCompanyName || page.title}</h3>
                            <div class="btn-container flex">
                                {/* <Button
                                    color={ButtonColors.Secondary}
                                    className="btn-icon btn-lg"
                                    button={page.helpButton} /> */}

                                <Button
                                    color={ButtonColors.Secondary}
                                    className="btn-icon"
                                    button={page.quizButton} />

                                {(1) && (
                                    <Button
                                        color={ButtonColors.Secondary}
                                        className="btn-icon"
                                        button={page.editButton} />
                                )}

                                <Button
                                    color={ButtonColors.Secondary}
                                    className="btn-icon"
                                    button={page.eventHistoryButton} />

                                <Button
                                    className="btn-icon"
                                    color={ButtonColors.Secondary}
                                    button={page.deactivateButton} />
                            </div>
                        </div>

                        <div class="customer-detail-container">
                            <div class={`customer-info-panel`}>
                                <div class="customer-info-section">
                                    <div class="info-label">Company URL</div>
                                    <div class="info-value">{customerCompany?.url || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Address</div>
                                    <div class="info-value">{customerCompanyLocation || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Phone</div>
                                    <div class="info-value">{customerCompany?.phone || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">ID | Date Added</div>
                                    <div class="info-value">{customerCompany?.id || ''} | {new Date(customerCompany?.createdDateTime).toLocaleDateString() || ''}</div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Comments</div>
                                    <div class="info-value">
                                        {/** customer?.comments || */ ''}
                                    </div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Annual Engagements</div>
                                    <div class="info-value">
                                        {/** customer?.comments || */ ''}
                                    </div>
                                </div>

                                <div class="customer-info-section">
                                    <div class="info-label">Employees</div>
                                    <div class="info-value">
                                        {customerCompany.customers ? customerCompany.customers.map(c => (
                                            <div key={c.id} onClick={() => page.navigateToCustomerDetailPage(c.id)} style={{ cursor: 'pointer' }}>{c.name}</div>
                                        )) : ''}
                                    </div>
                                </div>
                            </div>

                            <div class="customer-content-area">
                                <AllMeetingsTable table={page.meetingsTable} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerCompanyDetailPage;
